import React from "react";
import { FaEnvelope, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import ContactGrid from "../../sections/LandingPAge/ContactLinks";

const Footer = () => {
  const openInstagram = () => {
    window.open("https://instagram.com/ctrl.plusx", "_blank");
  };

  const openLinkedIn = () =>
    window.open(
      "https://www.linkedin.com/in/moussaoui-badreddine-692836250",
      "_blank"
    );

  const openWhatsApp = () => window.open("https://wa.me/213549075577", "_blank");

const openEmail = () => {
  window.location.href = "mailto:contact@ctrl-plusx.com?subject=Contact from Website&body=Hello CTRL+ Team,";
};



  const openFAQ = () => {
    window.location.href = "#faq";
  };

  return (
   <footer className="relative text-gray-100 border-t bg-emerald-800">
  <div className="container mx-auto px-6 lg:px-12 xl:px-20 py-8">
    
    {/* Main Grid */}
    <div className="grid gap-8 md:grid-cols-3 items-start">
      
      {/* Brand */}
      <div className="md:col-span-2 max-w-md">
        <h3 className="text-xl font-semibold text-white mb-2 tracking-wide">
          CTRL<span className="text-emerald-400">+</span>
        </h3>

        <p className="text-sm leading-relaxed mb-4">
          Apprenez l’architecture de manière structurée, moderne et orientée résultats.
        </p>
<div className="mb-4 text-sm">
          <a 
            href="mailto:contact@ctrl-plusx.com" 
            className="hover:text-emerald-300 transition"
          >
            contact@ctrl-plusx.com
          </a>
        </div>
        {/* Social Icons */}
        <div className="flex items-center gap-3">
          <button
            onClick={openInstagram}
            aria-label="Instagram"
            className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 hover:border-pink-400 hover:bg-pink-400/10 transition"
          >
            <FaInstagram className="w-4 h-4" />
          </button>

          <button
            onClick={openLinkedIn}
            aria-label="LinkedIn"
            className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 hover:border-emerald-400 hover:bg-emerald-400/10 transition"
          >
            <FaLinkedinIn className="w-4 h-4" />
          </button>

          <button
            onClick={openWhatsApp}
            aria-label="LinkedIn"
            className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 hover:border-emerald-400 hover:bg-emerald-400/10 transition"
          >
            <FaWhatsapp className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Navigation */}
      <div>
        <h4 className="text-xs font-semibold text-white mb-3 uppercase tracking-wider">
          Navigation
        </h4>

        <ul className="space-y-1.5 text-sm">
          {[
            { label: "Nos Cours", href: "#courses" },
            { label: "Services", href: "#services" },
            { label: "FAQ", href: "#faq" },
          ].map((item, i) => (
            <li key={i}>
              <a
                href={item.href}
                className="hover:text-emerald-300 transition"
              >
                {item.label}
              </a>
            </li>
          ))}

        
        </ul>
      </div>

    
    </div>

    {/* Divider */}
    <div className="my-6 h-px bg-white/5" />

    {/* Bottom */}
    <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-xs">
      <p>
        © 2025 <span className="text-white font-medium">CTRL+</span>
      </p>

      <p>
        Créé par{" "}
        <a
          href="https://www.facebook.com/chaima.la.363866/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-emerald-300 transition"
        >
          l’équipe Chaima
        </a>
      </p>
    </div>
  </div>
</footer>


 
  );
};

export default Footer; 